import React, { useRef } from 'react';
import { Dropdown } from 'react-bootstrap';
import ListAlt from '@mui/icons-material/ListAlt';
import DeleteOutline from '@mui/icons-material/DeleteOutline';
import './FinancialActionsMenu.css';
import { JdsMoreToggle } from '../../../../../../components/jds/JdsMoreToggle';

let idCounter = 0;

export const ListRow = ({
  labelPrimary,
  labelSecondary,
  value,
  primaryText = false,
  firstActionLabel,
  onFirstAction,
  secondActionLabel,
  onSecondAction,
}) => {
  const toggleId = useRef(`list-row-actions-toggle-${idCounter++}`);

  return (
    <div className="d-flex justify-content-between align-items-center">
      <span>
        {labelPrimary}
        {labelSecondary && (
          <>
            <span className="text-muted"> | </span>
            <span
              className="text-muted"
              style={{ textDecoration: 'underline' }}
            >
              {labelSecondary}
            </span>
          </>
        )}
      </span>
      <div
        className="d-flex align-items-center"
        style={{ gap: 'var(--space-12)' }}
      >
        {value && (
          <span
            style={{
              fontWeight: 'var(--fw-semibold)',
              color: primaryText ? 'var(--fg-brand-strong)' : undefined,
            }}
          >
            {value}
          </span>
        )}
        <Dropdown alignRight>
          <Dropdown.Toggle
            as={JdsMoreToggle}
            variant="outlined"
            size="sm"
            id={toggleId.current}
            aria-label="Opções"
          />
          <Dropdown.Menu>
            <Dropdown.Item onClick={onFirstAction}>
              <ListAlt fontSize="small" className="mr-2" />
              {firstActionLabel}
            </Dropdown.Item>
            <Dropdown.Item
              style={{ color: 'var(--fg-error-strong)' }}
              onClick={onSecondAction}
            >
              <DeleteOutline fontSize="small" className="mr-2" />
              {secondActionLabel}
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
};
